import React from "react";
import { CButton, CCard, CCardBody, CCardTitle } from "@coreui/react";
import { useAuth } from "../auth";

/**
 * Shown instead of the app layout when the authenticated user has no app
 * permissions (e.g. a fresh Google-SSO signup): no sidebar, no nav, no data
 * fetching — just who they are and the way out.
 */
const NoAccess = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body-tertiary">
      <CCard className="text-center" style={{ maxWidth: "26rem" }}>
        <CCardBody className="p-4">
          <CCardTitle className="mb-3">Cuenta sin permisos</CCardTitle>
          <p className="text-body-secondary">
            {user?.email ? (
              <>
                La cuenta <strong>{user.email}</strong> no tiene permisos
                asignados en el sistema.
              </>
            ) : (
              "Tu cuenta no tiene permisos asignados en el sistema."
            )}{" "}
            Contacta al administrador para que te asigne un rol.
          </p>
          <CButton
            color="primary"
            // returnTo policy (app base URL, allow-listed on the tenant) lives
            // inside the auth impl — see front/auth.
            onClick={() => logout()}
          >
            Cerrar sesión
          </CButton>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default NoAccess;
